import { Budgets } from "./location/budgets";
import {
  ClientsExpensesLineGraph,
  ClientsIncomesLineGraph,
  NonClientsExpensesLineGraph,
  NonClientsIncomesLineGraph
} from "./location/google-charts";
import { StackedChart } from "./location/stacked-chart";


window.addEventListener('DOMContentLoaded', () => {
  new StackedChart();
  new Budgets();
});

google.charts.load('current', { packages: ['corechart'], language: 'pl' });
google.charts.setOnLoadCallback(() => {
  if (window.isClient) {
    new ClientsIncomesLineGraph().draw();
    new ClientsExpensesLineGraph().draw();
  } else {
    new NonClientsIncomesLineGraph().draw();
    new NonClientsExpensesLineGraph().draw();
  }
});
